define("settings/components/cancel-plan/slide/features", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "later/utils/compare-strings", "later/utils/time-format", "@ember/template-factory"], function (_exports, _component, _service, _component2, _compareStrings, _timeFormat, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"later/utils/compare-strings",0,"later/utils/time-format",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <p class="tCA--title">
    {{#if this.hasActiveTrial}}
      {{t "account.change_plan.cancellation_feedback.features.title_trial"}}
    {{else}}
      {{t "account.change_plan.cancellation_feedback.features.title"}}
    {{/if}}
  </p>
  
  <div class="tCA--planContainer">
    <div class="tCA--planContainer__item">
      <p class="tCA--planContainer__title">
        <span class="tCA--title__underline">{{this.planName}}</span>
      </p>
      <p class="tCA--planContainer__subTitle">{{this.currentPlanSubtitle}}</p>
    </div>
  
    <div class="tCA--planContainer__item">
      {{svg-jar "arrow-right" class="o--icon"}}
    </div>
  
    <div class="tCA--planContainer__item">
      <p class="tCA--planContainer__title">
        <span class="tCA--title__underline tCA--title__underline--grey">
          {{t "account.change_plan.cancellation_feedback.free"}}
        </span>
      </p>
      <p class="tCA--planContainer__subTitle">
        {{t "account.change_plan.cancellation_feedback.features.plan_subtitles.free"}}
      </p>
    </div>
  </div>
  
  <hr />
  
  {{#if this.hasActiveTrial}}
    <p class="u--text--md">
      {{t
        "account.change_plan.cancellation_feedback.features.are_you_sure_trial"
        date=(moment-format this.trialExpiryMoment "MMM DD, YYYY")
      }}
    </p>
  {{else}}
    <p class="u--text--md">{{t "account.change_plan.cancellation_feedback.features.are_you_sure"}}</p>
  {{/if}}
  
  <ul class="tCA--featureList">
    {{#each this.features as |feature|}}
      <li class="tCA--featureList__li">
        {{svg-jar "close" class="o--icon u--m__r__xs"}}
        {{t (concat "account.change_plan.cancellation_feedback.features." feature)}}
      </li>
    {{/each}}
  </ul>
  */
  {
    "id": "vVUxFJo/",
    "block": "[[[10,2],[14,0,\"tCA--title\"],[12],[1,\"\\n\"],[41,[30,0,[\"hasActiveTrial\"]],[[[1,\"    \"],[1,[28,[35,1],[\"account.change_plan.cancellation_feedback.features.title_trial\"],null]],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[28,[35,1],[\"account.change_plan.cancellation_feedback.features.title\"],null]],[1,\"\\n\"]],[]]],[13],[1,\"\\n\\n\"],[10,0],[14,0,\"tCA--planContainer\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"tCA--planContainer__item\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"tCA--planContainer__title\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"tCA--title__underline\"],[12],[1,[30,0,[\"planName\"]]],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[14,0,\"tCA--planContainer__subTitle\"],[12],[1,[30,0,[\"currentPlanSubtitle\"]]],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"tCA--planContainer__item\"],[12],[1,\"\\n    \"],[1,[28,[35,2],[\"arrow-right\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"tCA--planContainer__item\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"tCA--planContainer__title\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"tCA--title__underline tCA--title__underline--grey\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"account.change_plan.cancellation_feedback.free\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[14,0,\"tCA--planContainer__subTitle\"],[12],[1,\"\\n      \"],[1,[28,[35,1],[\"account.change_plan.cancellation_feedback.features.plan_subtitles.free\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,\"hr\"],[12],[13],[1,\"\\n\\n\"],[41,[30,0,[\"hasActiveTrial\"]],[[[1,\"  \"],[10,2],[14,0,\"u--text--md\"],[12],[1,\"\\n    \"],[1,[28,[35,1],[\"account.change_plan.cancellation_feedback.features.are_you_sure_trial\"],[[\"date\"],[[28,[37,3],[[30,0,[\"trialExpiryMoment\"]],\"MMM DD, YYYY\"],null]]]]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],[[[1,\"  \"],[10,2],[14,0,\"u--text--md\"],[12],[1,[28,[35,1],[\"account.change_plan.cancellation_feedback.features.are_you_sure\"],null]],[13],[1,\"\\n\"]],[]]],[1,\"\\n\"],[10,\"ul\"],[14,0,\"tCA--featureList\"],[12],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,0,[\"features\"]]],null]],null],null,[[[1,\"    \"],[10,\"li\"],[14,0,\"tCA--featureList__li\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"close\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n      \"],[1,[28,[35,1],[[28,[37,6],[\"account.change_plan.cancellation_feedback.features.\",[30,1]],null]],null]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[1]],null],[13]],[\"feature\"],false,[\"if\",\"t\",\"svg-jar\",\"moment-format\",\"each\",\"-track-array\",\"concat\"]]",
    "moduleName": "settings/components/cancel-plan/slide/features.hbs",
    "isStrictMode": false
  });
  let FeaturesComponent = _exports.default = (_class = class FeaturesComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor3, this);
    }
    get hasActiveTrial() {
      return this.subscriptions.hasActiveTrial;
    }
    get isOnLegacyPlan() {
      return this.auth.currentAccount.get('isOnLegacyPlan');
    }
    get planType() {
      return this.subscriptionPlan?.planType;
    }
    get planName() {
      return this.subscriptionPlan?.name;
    }
    get subscription() {
      return this.subscriptions.subscription;
    }
    get subscriptionPlan() {
      return this.subscriptions.subscriptionPlan;
    }
    get trialExpiryMoment() {
      return this.auth.currentAccount.trialExpiryMoment;
    }
    get currentPlanSubtitle() {
      if (this.subscriptions.isOnAgencyPlan) {
        return '';
      }
      const planCode = this.isOnLegacyPlan && (0, _compareStrings.areStringsEqual)(this.planType, 'starter') ? 'starter_legacy' : this.planType;
      return this.intl.t(`account.change_plan.cancellation_feedback.features.plan_subtitles.${planCode}`);
    }
    get isNewUser() {
      const createdAt = moment(this.subscriptions.subscriptionCreatedAt * 1000);
      const daysSincePaid = (moment() - createdAt) / _timeFormat.convert.day().toMilliseconds();
      const thresholdForNewUser = 35;
      return daysSincePaid <= thresholdForNewUser;
    }
    get features() {
      if ((0, _compareStrings.areStringsEqual)(this.planType, 'creator')) {
        return ['media_kit', 'brand_campaigns', 'linkinbio', 'bttp'];
      }
      const featuresForNewUsers = ['bttp', 'hashtag_suggestions', 'first_comment', 'analytics', 'collect'];
      const featuresForOlderUsers = ['bttp', 'analytics', 'notes', 'collect'];
      return this.isNewUser ? featuresForNewUsers : featuresForOlderUsers;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FeaturesComponent);
});